import { AdditionalFieldInterface, UserInterface } from '@app/interfaces/_index';

import { User } from '../models/_index';
import { Adapter } from './adapter';
import { AdditionalFieldAdapter } from './additional-field.adapter';

/**
 * Adapts raw user object to a User Model
 * NOTE: The item fields are the default json property names.
 */
export class UserAdapter implements Adapter<User> {
  private addFieldAdapter: AdditionalFieldAdapter;

  constructor() {
    this.addFieldAdapter = new AdditionalFieldAdapter();
  }

  /**
   * Convert Docebo User response into User model
   * @param item - has User object response User Interface
   * @returns - adapted User object to User object model
   */
  adapt(item: UserInterface): User {
    let adaptedUser: User;
    let additionalFields = [];
    if (item && item.user_data) {
      additionalFields =
        item.additional_fields &&
        item.additional_fields.map((field: AdditionalFieldInterface) =>
          this.addFieldAdapter.adapt(field)
        );
      adaptedUser = new User(
        item.user_data.user_id,
        item.user_data.username,
        item.user_data.first_name,
        item.user_data.last_name,
        item.user_data.email,
        item.user_data.avatar,
        additionalFields,
        [],
        []
      );
    }
    return adaptedUser;
  }
}
